import { createTheme, ThemeProvider } from "@mui/material";
import React, { FC, ReactNode, useEffect, useState } from "react";
import CloseSiteDialog from "../../close-site-dialog/close-site-dialog";
import NotificationContainer from "../../notification/notificationContainer";
import { NavAnchor } from "../nav-anchor";
import { NewFooter } from "../new-footer";
import { NewSidebar } from "../new-sidebar";
import * as styles from "./new-layout.module.scss";

interface NewLayoutProps {
  children: ReactNode;
}

export const NewLayout: FC<NewLayoutProps> = ({ children }) => {
  const theme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#ff9b74",
      },
      secondary: {
        main: "#d6cfca",
      },
    },
    components: {
      // MuiButton: {
      //   styleOverrides: {
      //     root: ({ ownerState }) => ({
      //       display: "flex",
      //       alignItems: "center",
      //       justifyContent: "center",
      //       flex: "0 0 auto",
      //       padding: "10px 16px",
      //       borderRadius: "8px",
      //       // border: "1px solid var(--gold-500)",
      //       fontFamily: "var(--second-family), Roboto, sans-serif",
      //       fontWeight: 400,
      //       fontSize: "16px",
      //       color: "var(--white-50)",
      //       cursor: "pointer",
      //       transition: "var(--transition-1)",
      //       textTransform: "none",
      //       // Optional: hover effect
      //       // "&:hover": {
      //       //   backgroundColor: "rgba(255, 155, 116, 0.1)",
      //       //   borderColor: "var(--gold-500)",
      //       // },
      //       // Outlined variant
      //       "&.MuiButton-outlined": {
      //         // backgroundColor: "#2a2b2d",
      //         borderWidth: "2px",
      //       },
      //       // Disabled state
      //       // "&.Mui-disabled": {
      //       //   backgroundColor: "#3a3b3d",
      //       //   color: "#8c8c8c",
      //       //   borderColor: "#5a5a5a",
      //       //   cursor: "not-allowed",
      //       // },
      //     }),
      //   },
      // },
    },
  });
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setShowContent(true);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div
        className={`${styles.layout} ${showContent ? styles.initialized : ""}`}
      >
        <div>
          <NewSidebar></NewSidebar>
          <div className={styles.navBarSafeArea}></div>
          {children}
        </div>

        <div>
          <NavAnchor />
          <NewFooter></NewFooter>
          <CloseSiteDialog />
          <NotificationContainer />
        </div>
      </div>
    </ThemeProvider>
  );
};
